<template>
  <BaseLoading
    v-if="isLoading"
    full-screen
  />
  <div
    v-else
    class="d-flex flex-column align-items-center text-center"
  >
    <template v-if="!isError">
      <font-awesome-icon
        :class="$style.icon"
        class="mb-4"
        icon="check-circle"
        size="6x"
      />
      <BaseTextH1 class="pt-4">
        {{ $t('your-email-has-been-verified') }}
      </BaseTextH1>
      <p class="pb-4">
        {{ $t('you-are-ready-to-win-the-prize') }}
      </p>
      <router-link :to="{name: 'home'}">
        <BaseButton
          class="mt-4"
          is-rounded
          variant="green"
        >
          <span class="px-2">{{ $t('play-now') }}</span>
        </BaseButton>
      </router-link>
    </template>
    <template v-else>
      <font-awesome-icon
        :class="$style.icon"
        icon="exclamation-triangle"
        size="6x"
      />
      <BaseTextH1 class="pt-4">
        {{ $t('ooops') }}
      </BaseTextH1>
      <p>{{ $t('we-were-unable-to-verify-your-email') }}</p>
    </template>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import BaseTextH1 from '@/components/Atoms/Typography/BaseTextH1'
import BaseLoading from '@/components/Atoms/BaseLoading'
import BaseButton from '@/components/Atoms/BaseButton'

export default {
  name: 'EmailVerificationConfirmation',
  components: { BaseButton, BaseLoading, BaseTextH1 },
  metaInfo() {
    return {
      title: this.$t('page-titles.email-verification'),
    }
  },
  data() {
    return {
      isLoading: false,
      isError: false,
    }
  },
  created() {
    this.isLoading = true
    this.postValidateEmail({
      hash: this.$route.params.hash,
    }).then(({ error }) => {
      this.isLoading = false
      this.isError = !!error
    })
  },
  methods: {
    ...mapActions({
      postValidateEmail: 'profile/emailValidation/postValidateEmail',
    }),
  },
}
</script>

<style module lang="scss">
  @import "../../../../assets/scss/variables.scss";
  .icon {
    color: $color-tomato;
  }
</style>
